import { ObjectId } from "mongodb";
import { AutomationDto } from "../types/automation";

export interface ScheduledTask<T = any> {
    _id: ObjectId;
    type: string;
    lastModifiedAt: Date;
    lockedAt: Date;
    failCount: number;
    failReason: string;
    failedAt: Date;
    nextRunAt: Date;
    finishedAt: Date;
    lastRunAt: Date;
    scheduledAt: Date;
    createdAt: Date;
    endAt?: Date;
    progress: number;
    roundIdx: number;
    isPaused: boolean;
    data: T;
}

export interface TaskResult {
    template?: any;
    studiosProjectId?: ObjectId;
    automationDto?: AutomationDto;
    automationJobId?: ObjectId;
    streams?: any[];
    project?: any;
}

export enum SchedulerExportErrorMsg {
    NO_CREDIT= "Insufficient Credits",
    NO_SUBSCRIPTION= "Too many scenes"
}

export enum SeriesSchedule {
    INSTANT='instant',
    DAILY='daily',
    WEEKLY='weekly',
    NONE='none'
}